// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* submenus */

sf-submenu .sf-expand-collapse-indicator {
  display: inline-block;
  width: 0.5em;
  transition: all 0.1s ease-in;
}

sf-submenu.sf-submenu-expand > button > span.sf-expand-collapse-indicator {
  transform: rotate(90deg);
  transition: all 0.1s ease-in;
}

sf-submenu div {
  display: block;
  position: absolute;
  padding-left: 0;
  background-color: #f9f9f9;
  min-width: 2em;
  white-space: nowrap;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  background-color: #eee;
  opacity: 0;
  visibility: hidden;
  /* transition opacity and make invisible after transition period on submenu close */
  transition:
    opacity 0.1s ease-in,
    visibility linear 0.1s;
}

sf-submenu.sf-submenu-expand > div {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.1s ease-in;
}

/* first level submenus */

sf-submenu > div {
  top: 100%;
}

/* nested submenus */

sf-submenu > div sf-submenu div {
  top: 0%;
  left: 100%;
}

/* mobile */

@media screen and (max-width: 576px) {
  sf-submenu div {
    box-shadow: none;
    /* position cannot be transitioned, so rather make submenu immediately invisible on close */
    transition: none;
  }
  sf-submenu.sf-submenu-expand > div {
    padding-left: 1em;
    position: inherit;
  }
  sf-submenu > div {
    top: 0%;
  }
  sf-submenu > div sf-submenu div {
    left: 0%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/Submenu.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF,aAAa;;AAEb;EACE,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,mFAAmF;EACnF;;0BAEwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,yBAAyB;;AAEzB;EACE,SAAS;AACX;;AAEA,oBAAoB;;AAEpB;EACE,OAAO;EACP,UAAU;AACZ;;AAEA,WAAW;;AAEX;EACE;IACE,gBAAgB;IAChB,2FAA2F;IAC3F,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\n/* submenus */\n\nsf-submenu .sf-expand-collapse-indicator {\n  display: inline-block;\n  width: 0.5em;\n  transition: all 0.1s ease-in;\n}\n\nsf-submenu.sf-submenu-expand > button > span.sf-expand-collapse-indicator {\n  transform: rotate(90deg);\n  transition: all 0.1s ease-in;\n}\n\nsf-submenu div {\n  display: block;\n  position: absolute;\n  padding-left: 0;\n  background-color: #f9f9f9;\n  min-width: 2em;\n  white-space: nowrap;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  background-color: #eee;\n  opacity: 0;\n  visibility: hidden;\n  /* transition opacity and make invisible after transition period on submenu close */\n  transition:\n    opacity 0.1s ease-in,\n    visibility linear 0.1s;\n}\n\nsf-submenu.sf-submenu-expand > div {\n  opacity: 1;\n  visibility: visible;\n  transition: opacity 0.1s ease-in;\n}\n\n/* first level submenus */\n\nsf-submenu > div {\n  top: 100%;\n}\n\n/* nested submenus */\n\nsf-submenu > div sf-submenu div {\n  top: 0%;\n  left: 100%;\n}\n\n/* mobile */\n\n@media screen and (max-width: 576px) {\n  sf-submenu div {\n    box-shadow: none;\n    /* position cannot be transitioned, so rather make submenu immediately invisible on close */\n    transition: none;\n  }\n  sf-submenu.sf-submenu-expand > div {\n    padding-left: 1em;\n    position: inherit;\n  }\n  sf-submenu > div {\n    top: 0%;\n  }\n  sf-submenu > div sf-submenu div {\n    left: 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
